// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".OfferIcon[data-v-763cf360]{display:inline-block;width:1em;line-height:1}\n", ""]);
// Exports
module.exports = exports;
